module.exports = __webpack_public_path__ + "img/marisa kirisame scarlet_lw.5f39a322.png";